import { useState, useEffect } from 'react';
import './EventsPage.css';
import { apiRequest } from '../../Services/api';
import { toast } from 'react-toastify';
import { formatEasternDate } from '../../Utils/dateTime';

function EventsPage() {
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let active = true;
    apiRequest('/events/index.php')
      .then((data) => {
        if (!active) return;
        if (!Array.isArray(data?.events)) {
          setUpcomingEvents([]);
          toast.error('Events could not be loaded because the server returned an unexpected response.');
          return;
        }
        setUpcomingEvents(data.events);
      })
      .catch((error) => toast.error(error.message))
      .finally(() => {
        if (active) setIsLoading(false);
      });
    return () => { active = false; };
  }, []);

  function formatDate(rawDate) {
    return formatEasternDate(rawDate, { year: 'numeric', month: 'long', day: 'numeric' });
  }

  const events = Array.isArray(upcomingEvents) ? upcomingEvents : [];

  return (
    <div className='events-page'>
      <section className='events-hero'>
        <div className='events-hero-inner'>
          <p className='events-hero-eyebrow'>Community calendar</p>
          <h1>Upcoming boils &amp; pop-ups</h1>
          <p>
            Follow the aroma! Here&apos;s where you can grab a warm bag of Aunt Jack&apos;s peanuts in the coming weeks. Bring the family,
            say hello, and don&apos;t forget to preorder gallons for your own gathering.
          </p>
        </div>
      </section>

      <div className='events-shell'>
        <div className='events-layout'>
          <div className='events-list-card'>
            <div className='events-list-header'>
              <h2>Upcoming events</h2>
              <p>Check back often&mdash;our calendar fills up fast once fall football kicks off!</p>
            </div>
            <div className='events-list' aria-live='polite'>
              {isLoading ? (
                <div className='events-loading'>Checking the calendar…</div>
              ) : events.length === 0 ? (
                <div className='events-empty-state'>
                  <span className='events-empty-date' aria-hidden='true'>—</span>
                  <h3>No current events scheduled</h3>
                  <p>New markets, pop-ups, and community events will appear here as soon as dates are confirmed.</p>
                </div>
              ) : (
                events.map((event) => (
                  <div key={event.id} className='events-list-item'>
                    <div className='event-date'>
                      <span>{formatDate(event.date)}</span>
                    </div>
                    <div className='event-details'>
                      <h3>{event.eventTitle}</h3>
                      <p className='event-location'>{event.location}</p>
                      <p className='event-description'>{event.details}</p>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EventsPage;
